const OVERSEAS_LANGUAGE_SELECTOR_ENABLED = false;

// Language selector component
interface LanguageSelectorProps {
  currentLanguage: string;
  onLanguageChange: (lang: string) => void;
  isOverseas: boolean;
}

export const LanguageSelector = ({
  currentLanguage,
  onLanguageChange,
  isOverseas,
}: LanguageSelectorProps) => {
  if (isOverseas && !OVERSEAS_LANGUAGE_SELECTOR_ENABLED) return null;

  return (
    <div className='lang-btn-wrap relative transition-all duration-200'>
      <div className='lang-btn item-default relative flex h-[40px] items-center justify-between text-[16px] leading-[32px] xl:h-8'>
        {/* 글로벌 아이콘 */}
        <div className='mr-2 w-5'>
          <img
            className='hidden h-auto w-full group-[.header-white]:block'
            src='/images/icons/icon_language.svg'
            alt=''
          />
          <img
            className='block h-auto w-full group-[.header-white]:hidden'
            src='/images/icons/icon_language_w.svg'
            alt=''
          />
        </div>

        {isOverseas ? (
          /* 해외향: EN | JA */
          <div className='item-user-wrap flex items-center gap-2'>
            <button
              type='button'
              className='lang-btn item-user flex h-8 cursor-pointer items-center justify-center border-none bg-transparent text-sm leading-[32px] transition duration-200 xl:justify-between xl:text-base'
              onClick={() => onLanguageChange('en')}
              aria-label='Change to English'
            >
              <span
                className={`lang-txt text-white group-[.header-white]:text-black ${currentLanguage === 'en' ? 'opacity-100' : 'opacity-30'}`}
              >
                EN
              </span>
            </button>
            <p className='leading-none text-black/30'>|</p>
            <button
              type='button'
              className='lang-btn item-user flex h-8 cursor-pointer items-center justify-center border-none bg-transparent text-sm leading-[32px] transition duration-200 xl:justify-between xl:text-base'
              onClick={() => onLanguageChange('ja')}
              aria-label='日本語に変更'
            >
              <span
                className={`lang-txt text-white group-[.header-white]:text-black ${currentLanguage === 'ja' ? 'opacity-100' : 'opacity-30'}`}
              >
                JA
              </span>
            </button>
          </div>
        ) : (
          /* 국내향: KO | EN */
          <div className='item-user-wrap flex items-center gap-2'>
            <button
              type='button'
              className='lang-btn item-user flex h-8 cursor-pointer items-center justify-center border-none bg-transparent text-sm leading-[32px] transition duration-200 xl:justify-between xl:text-base'
              onClick={() => onLanguageChange('ko')}
              aria-label='한국어로 변경'
            >
              <span
                className={`lang-txt text-white group-[.header-white]:text-black ${currentLanguage === 'ko' ? 'opacity-100' : 'opacity-30'}`}
              >
                KO
              </span>
            </button>
            <p className='leading-none text-black/30'>|</p>
            <button
              type='button'
              className='lang-btn item-user flex h-8 cursor-pointer items-center justify-center border-none bg-transparent text-sm leading-[32px] transition duration-200 xl:justify-between xl:text-base'
              onClick={() => onLanguageChange('en')}
              aria-label='Change to English'
            >
              <span
                className={`lang-txt text-white group-[.header-white]:text-black ${currentLanguage === 'en' ? 'opacity-100' : 'opacity-30'}`}
              >
                EN
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
